var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form-button-disabler",
    { staticClass: "grid grid-cols-1 gap-4 simple-internal-data-import-modal" },
    [
      _c(
        "field",
        { attrs: { label: "Import Type" } },
        [
          _c("dropdown-field", {
            attrs: {
              source: _vm.importTypes,
              placeholder: "Select an Import Type",
            },
            model: {
              value: _vm.importType,
              callback: function ($$v) {
                _vm.importType = $$v
              },
              expression: "importType",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          attrs: {
            label: "Import File *",
            "error-text": _vm.getValidationErrorText("file"),
          },
        },
        [
          _c("file-field", {
            attrs: { accept: ".xls,.xlsx" },
            model: {
              value: _vm.file,
              callback: function ($$v) {
                _vm.file = $$v
              },
              expression: "file",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-3 gap-2" },
        [
          _c(
            "field",
            {
              staticClass: "pr dropdown-w",
              attrs: {
                label: "Tab Name *",
                disabled: _vm.file === null,
                "error-text": _vm.getValidationErrorText("tabIndex"),
              },
            },
            [
              _c("dropdown-field", {
                attrs: {
                  source: _vm.excelTabs,
                  "text-field": "name",
                  "value-field": "index",
                },
                model: {
                  value: _vm.tabIndex,
                  callback: function ($$v) {
                    _vm.tabIndex = $$v
                  },
                  expression: "tabIndex",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "field",
            {
              staticClass: "pr",
              attrs: {
                label: "Header Row (eg. 1 or 1-2)",
                disabled: _vm.file === null,
                "error-text": _vm.getValidationErrorText("haderRow"),
              },
            },
            [
              _c("range-field", {
                attrs: {
                  minValue: _vm.headerRowMinValue,
                  maxValue: _vm.headerRowMaxValue,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "field",
            {
              attrs: {
                label: "Data Row",
                disabled: _vm.file === null,
                "error-text": _vm.getValidationErrorText("dataRow"),
              },
            },
            [
              _c("number-field", {
                model: {
                  value: _vm.dataRow,
                  callback: function ($$v) {
                    _vm.dataRow = $$v
                  },
                  expression: "dataRow",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.importType === "Mapping",
              expression: "importType === 'Mapping'",
            },
          ],
          attrs: {
            label: "Mapping *",
            "error-text": _vm.getValidationErrorText("mappingId"),
          },
        },
        [
          _c("mapping-dropdown-field", {
            attrs: { "import-process-id": _vm.importProcessId },
            model: {
              value: _vm.mappingId,
              callback: function ($$v) {
                _vm.mappingId = $$v
              },
              expression: "mappingId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("checkbox", {
            attrs: { label: "Allow mapped NULLs to overwrite previous values" },
            model: {
              value: _vm.keepNull,
              callback: function ($$v) {
                _vm.keepNull = $$v
              },
              expression: "keepNull",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex items-center pt-2" },
        [
          _c(
            "action",
            {
              staticClass: "ml-2",
              attrs: {
                href: "/DataImport/InternalDataImport",
                icon: "mdi mdi-chevron-left",
              },
            },
            [_vm._v("Go To Advanced")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-grow" }),
          _vm._v(" "),
          _c(
            "btn",
            {
              attrs: { loading: _vm.saving },
              on: {
                click: function ($event) {
                  return _vm.submitModal()
                },
              },
            },
            [_vm._v("Import")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }